import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostLocationMappingAPI } from "../../api/create";
import { getPCCLocation } from "../../api/list";
import { NotesErrorPutAPI } from "../../api/update";


// Async thunk for location mapping that doesn't modify state
export const mapLocation = createAsyncThunk(
    'notes/mapLocation',
    async (payload: any, { rejectWithValue }) => {
      try {
        const response = await PostLocationMappingAPI(payload);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to map location');
      }
    }
  );


export const fetchPCClocations = createAsyncThunk(
    'notes/fetchPCClocations',
    async (payload: any, { rejectWithValue }) => {
      try {
        const response = await getPCCLocation(payload);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch PCC locations');
      }
    }
  );


  export const NotesErrorUpdate = createAsyncThunk(
    'notes/NotesErrorUpdate',
    async (
      { id, payload }: { id: any; payload: any },
      { rejectWithValue }
    ) => {
      try {
        const response = await NotesErrorPutAPI(id, payload);
        return response;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data || 'Failed to update notes error'
        );
      }
    }
  );